import { Button, Grid, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import { CustomTable } from "../../../shared";

function SpecsheetSection({
  state,
  columns,
  pdfRef,
  addPdfHandler,
  handleDropzonePdf,
  createPdfUrl,
}) {
  return (
    <Grid
      container
      gap="24px"
      py="24px"
      borderBottom="1px solid"
      borderColor="divider"
    >
      <Grid item xs={12} md={4}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ width: "150px" }}
        >
          Spec Sheet
        </Typography>
      </Grid>

      <Grid item flex={1}>
        <CustomTable
          defaultData={state.data.pdf ?? []}
          columns={columns}
          isPagination={false}
          isTableHeader={false}
          isLoading={createPdfUrl.isPending}
          tableFooter={
            <Stack
              direction="row"
              alignItems="center"
              backgroundColor="#ffffff"
              sx={{
                mx: "8px",
                mb: "8px",
                border: 1,
                borderTop: 0,
                borderColor: "divider",
                height: "52px",
                px: "12px",
              }}
            >
              <div>
                <Button
                  type="button"
                  size="small"
                  variant="text"
                  startIcon={<AddIcon />}
                  onClick={(event) =>
                    addPdfHandler(event, state.data.pdf.length)
                  }
                >
                  Add Files
                </Button>
                <input
                  id="contained-button-file"
                  type="file"
                  onChange={handleDropzonePdf}
                  style={{ display: "none" }}
                  ref={pdfRef}
                />
              </div>
            </Stack>
          }
        />

        <Stack direction="row" mt={1}>
          <InfoIcon sx={{ height: "13px", color: "#485364", mt: 0.5 }} />
          <Typography color="#485364" fontSize="14px" fontWeight={400}>
            Supported format: PDF
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default SpecsheetSection;
